import React from "react";
import { Autocomplete, TextField } from "@mui/material";

import "./PullListWorkflowFilters.css";

const PullListWorkflowFilters = ({ filters, setFilters, workflows }) => {
    const filterWorkflowsExcept = (excludedFilterKey) => {
        return workflows.filter(workflow => {
            for (const filterKey in filters) {
                if (filterKey === excludedFilterKey) {
                    continue;
                }

                const selectedOptions = filters[filterKey];

                if (selectedOptions?.length && !selectedOptions.some(option => workflow[filterKey]?.includes(option))
                ) {
                    return false;
                }
            }
            return true;
        });
    };

    const areaWorkflows = filterWorkflowsExcept("area");
    const protocolWorkflows = filterWorkflowsExcept("protocol");
    const biologistWorkflows = filterWorkflowsExcept("managedBy");
    const labWorkflows = filterWorkflowsExcept("labs");
    const assayWorkflows = filterWorkflowsExcept("assayType");

    const shipmentFromRepo = ["Yes", "No", "Sample Disposal"];
    const statuses = ["Real Time", "Pull List Development", "Pending Pull List Approval", "Pull List Approved", "Submitted to Repository", "Pull List Executed", "Results Data Processing", "Pending Follow-up", "Completed", "Withdrawn"];
    const areas = [...new Set(areaWorkflows.flatMap(workflow => (workflow.area ? workflow.area.split(",") : [])).map(area => area.trim()).filter(Boolean))].sort();
    const protocols = [...new Set(protocolWorkflows.flatMap(workflow => (workflow.protocol ? workflow.protocol.split(",") : [])).map(area => area.trim()).filter(Boolean))].sort();
    const biologists = [...new Set(biologistWorkflows.flatMap(workflow => (workflow.managedBy ? workflow.managedBy.split(",") : [])).map(area => area.trim()).filter(Boolean))].sort();
    const labs = [...new Set(labWorkflows.map(workflow => workflow.labs))].filter(lab => lab !== null).sort();
    const assays = [...new Set(assayWorkflows.flatMap(workflow => (workflow.assayType ? workflow.assayType.split(",") : [])).map(area => area.trim()).filter(Boolean))].sort();

    const handleFilterChange = (filterKey, selectedOptions) => {
        setFilters({ ...filters, [filterKey]: selectedOptions });
    };

    return (
        <div className="workflowFilterWindow" onClick={(e) => e.stopPropagation()}>
            <div className="workflowFilterGroup">
                <Autocomplete
                    multiple
                    options={shipmentFromRepo}
                    value={!filters.shipmentFromRepo ? [] : filters.shipmentFromRepo}
                    onChange={(_, selectedOptions) => handleFilterChange("shipmentFromRepo", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Shipment from Repo"}
                            sx={{ ...(filters.shipmentFromRepo && filters.shipmentFromRepo.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="workflowFilterGroup">
                <Autocomplete
                    multiple
                    options={statuses}
                    value={!filters.plStatus ? [] : filters.plStatus}
                    onChange={(_, selectedOptions) => handleFilterChange("plStatus", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Status"}
                            sx={{ ...(filters.plStatus && filters.plStatus.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="workflowFilterGroup">
                <Autocomplete
                    multiple
                    options={areas}
                    value={!filters.area ? [] : filters.area}
                    onChange={(_, selectedOptions) => handleFilterChange("area", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Area"}
                            sx={{ ...(filters.area && filters.area.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="workflowFilterGroup">
                <Autocomplete
                    multiple
                    options={protocols}
                    value={!filters.protocol ? [] : filters.protocol}
                    onChange={(_, selectedOptions) => handleFilterChange("protocol", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Study Number"}
                            sx={{ ...(filters.protocol && filters.protocol.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="workflowFilterGroup">
                <Autocomplete
                    multiple
                    options={biologists}
                    value={!filters.managedBy ? [] : filters.managedBy}
                    onChange={(_, selectedOptions) => handleFilterChange("managedBy", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Biologist"}
                            sx={{ ...(filters.managedBy && filters.managedBy.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="workflowFilterGroup">
                <Autocomplete
                    multiple
                    options={labs}
                    value={!filters.labs ? [] : filters.labs}
                    onChange={(_, selectedOptions) => handleFilterChange("labs", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Lab"}
                            sx={{ ...(filters.labs && filters.labs.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
            <div className="workflowFilterGroup">
                <Autocomplete
                    multiple
                    options={assays}
                    value={!filters.assayType ? [] : filters.assayType}
                    onChange={(_, selectedOptions) => handleFilterChange("assayType", selectedOptions)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={"Assay Type"}
                            sx={{ ...(filters.assayType && filters.assayType.length && { backgroundColor: "#cceeff" }) }}
                        />
                    }
                />
            </div>
        </div>
    );
}

export default PullListWorkflowFilters;